/* src/app/modules/shared/components/column/column-product-tag-group/column-product-tag-group.component.scss */
app-column-product-tag-group {
  display: contents;
}
/*# sourceMappingURL=column-product-tag-group.component.css.map */
